import { Link } from "react-router-dom"

export default function PrivacyPage() {
  const currentYear = new Date().getFullYear()

  return (
    <article
      style={{
        maxWidth: 760,
        width: "100%",
        margin: "0 auto",
        padding: "clamp(24px, 6vw, 48px) clamp(20px, 4vw, 32px)",
        display: "grid",
        gap: "clamp(20px, 3vw, 28px)",
      }}
    >
      <header>
        <h1
          className="mono"
          style={{
            letterSpacing: "0.14em",
            textTransform: "uppercase",
            fontSize: "clamp(1.4rem, 4vw, 1.8rem)",
            marginBottom: "12px",
          }}
        >
          Privacy Policy
        </h1>
        <p className="small" style={{ color: "var(--muted)" }}>
          Last Updated: January {currentYear}
        </p>
      </header>

      <section>
        <h2
          className="mono"
          style={{
            letterSpacing: "0.1em",
            textTransform: "uppercase",
            fontSize: "1rem",
            marginBottom: "12px",
            color: "var(--accent-text)",
          }}
        >
          Overview
        </h2>
        <p style={{ color: "var(--text)", lineHeight: 1.7 }}>
          Sales Demon (&ldquo;we,&rdquo; &ldquo;us,&rdquo; &ldquo;our&rdquo;) is committed to protecting your privacy. This policy
          explains how we collect, use, and safeguard your information when you use our
          invoicing and payment notification service.
        </p>
      </section>

      <section>
        <h2
          className="mono"
          style={{
            letterSpacing: "0.1em",
            textTransform: "uppercase",
            fontSize: "1rem",
            marginBottom: "12px",
            color: "var(--accent-text)",
          }}
        >
          Information We Collect
        </h2>
        <p style={{ color: "var(--text)", lineHeight: 1.7, marginBottom: "12px" }}>
          We collect information necessary to provide our service:
        </p>
        <ul style={{ color: "var(--muted)", lineHeight: 1.8, paddingLeft: "20px" }}>
          <li>
            <strong style={{ color: "var(--text)" }}>Account Information:</strong> Name, email
            address, phone number, business name
          </li>
          <li>
            <strong style={{ color: "var(--text)" }}>Payment Information:</strong> Stripe
            connection details (we do not store card numbers)
          </li>
          <li>
            <strong style={{ color: "var(--text)" }}>Usage Data:</strong> Invoices created,
            messages sent, feature usage
          </li>
          <li>
            <strong style={{ color: "var(--text)" }}>Message Content:</strong> Text messages
            exchanged with your Sales Demon number
          </li>
        </ul>
      </section>

      <section>
        <h2
          className="mono"
          style={{
            letterSpacing: "0.1em",
            textTransform: "uppercase",
            fontSize: "1rem",
            marginBottom: "12px",
            color: "var(--accent-text)",
          }}
        >
          SMS and Mobile Communications
        </h2>
        <p style={{ color: "var(--text)", lineHeight: 1.7, marginBottom: "16px" }}>
          When you opt in to SMS notifications, we collect and process the following:
        </p>

        <h3
          className="mono small"
          style={{
            letterSpacing: "0.08em",
            textTransform: "uppercase",
            marginBottom: "10px",
            color: "var(--text)",
          }}
        >
          SMS Data Collected
        </h3>
        <ul style={{ color: "var(--muted)", lineHeight: 1.8, paddingLeft: "20px", marginBottom: "16px" }}>
          <li>Your mobile phone number</li>
          <li>Your consent to receive SMS messages</li>
          <li>Message delivery status and timestamps</li>
          <li>Your responses to messages (e.g., STOP, HELP, commands)</li>
        </ul>

        <h3
          className="mono small"
          style={{
            letterSpacing: "0.08em",
            textTransform: "uppercase",
            marginBottom: "10px",
            color: "var(--text)",
          }}
        >
          How We Use SMS Data
        </h3>
        <ul style={{ color: "var(--muted)", lineHeight: 1.8, paddingLeft: "20px", marginBottom: "16px" }}>
          <li>Send notifications about invoices you create</li>
          <li>Alert you when customers make payments</li>
          <li>Send automated payment reminders on your behalf</li>
          <li>Provide account-related updates and alerts</li>
          <li>Respond to your text commands</li>
        </ul>

        <h3
          className="mono small"
          style={{
            letterSpacing: "0.08em",
            textTransform: "uppercase",
            marginBottom: "10px",
            color: "var(--text)",
          }}
        >
          SMS Data Sharing
        </h3>
        <div
          style={{
            background: "rgba(255, 43, 79, 0.08)",
            border: "1px solid rgba(255, 43, 79, 0.2)",
            padding: "16px",
            marginBottom: "16px",
          }}
        >
          <p style={{ color: "var(--text)", lineHeight: 1.7, margin: 0 }}>
            <strong>We do not sell, rent, or share your phone number or SMS opt-in data with
            third parties for marketing or promotional purposes.</strong>
          </p>
        </div>
        <p style={{ color: "var(--muted)", lineHeight: 1.7, marginBottom: "12px" }}>
          We may share your phone number only with:
        </p>
        <ul style={{ color: "var(--muted)", lineHeight: 1.8, paddingLeft: "20px" }}>
          <li>
            <strong style={{ color: "var(--text)" }}>Twilio:</strong> Our SMS service provider,
            solely to deliver messages
          </li>
          <li>
            <strong style={{ color: "var(--text)" }}>Service Providers:</strong> Who assist in
            customer support, under confidentiality agreements
          </li>
        </ul>

        <h3
          className="mono small"
          style={{
            letterSpacing: "0.08em",
            textTransform: "uppercase",
            marginTop: "16px",
            marginBottom: "10px",
            color: "var(--text)",
          }}
        >
          SMS Data Retention
        </h3>
        <p style={{ color: "var(--muted)", lineHeight: 1.7 }}>
          We retain SMS-related data (phone numbers, message logs, consent records) for as long
          as your account is active or as needed to provide services. You can request deletion
          of your data by contacting support@salesdemon.ai.
        </p>
      </section>

      <section>
        <h2
          className="mono"
          style={{
            letterSpacing: "0.1em",
            textTransform: "uppercase",
            fontSize: "1rem",
            marginBottom: "12px",
            color: "var(--accent-text)",
          }}
        >
          How We Use Your Information
        </h2>
        <ul style={{ color: "var(--muted)", lineHeight: 1.8, paddingLeft: "20px" }}>
          <li>Provide and improve our invoicing and notification services</li>
          <li>Process payments through your connected Stripe account</li>
          <li>Send transactional communications about your account</li>
          <li>Respond to support requests</li>
          <li>Comply with legal obligations</li>
        </ul>
      </section>

      <section>
        <h2
          className="mono"
          style={{
            letterSpacing: "0.1em",
            textTransform: "uppercase",
            fontSize: "1rem",
            marginBottom: "12px",
            color: "var(--accent-text)",
          }}
        >
          Data Sharing
        </h2>
        <p style={{ color: "var(--text)", lineHeight: 1.7, marginBottom: "12px" }}>
          We share data only as necessary to provide our service:
        </p>
        <ul style={{ color: "var(--muted)", lineHeight: 1.8, paddingLeft: "20px" }}>
          <li>
            <strong style={{ color: "var(--text)" }}>Stripe:</strong> For payment processing
          </li>
          <li>
            <strong style={{ color: "var(--text)" }}>Twilio:</strong> For SMS delivery
          </li>
          <li>
            <strong style={{ color: "var(--text)" }}>Infrastructure Providers:</strong> For
            hosting and data storage
          </li>
        </ul>
        <p style={{ color: "var(--muted)", lineHeight: 1.7, marginTop: "12px" }}>
          We do not sell your personal information to third parties.
        </p>
      </section>

      <section>
        <h2
          className="mono"
          style={{
            letterSpacing: "0.1em",
            textTransform: "uppercase",
            fontSize: "1rem",
            marginBottom: "12px",
            color: "var(--accent-text)",
          }}
        >
          Your Rights and Choices
        </h2>
        <ul style={{ color: "var(--muted)", lineHeight: 1.8, paddingLeft: "20px" }}>
          <li>
            <strong style={{ color: "var(--text)" }}>Opt-out of SMS:</strong> Reply STOP to any
            message or update preferences in your account
          </li>
          <li>
            <strong style={{ color: "var(--text)" }}>Access Your Data:</strong> Request a copy
            of your data by contacting support
          </li>
          <li>
            <strong style={{ color: "var(--text)" }}>Delete Your Data:</strong> Request deletion
            by emailing support@salesdemon.ai
          </li>
          <li>
            <strong style={{ color: "var(--text)" }}>Update Information:</strong> Edit your
            profile in account settings
          </li>
        </ul>
      </section>

      <section>
        <h2
          className="mono"
          style={{
            letterSpacing: "0.1em",
            textTransform: "uppercase",
            fontSize: "1rem",
            marginBottom: "12px",
            color: "var(--accent-text)",
          }}
        >
          Data Security
        </h2>
        <p style={{ color: "var(--text)", lineHeight: 1.7 }}>
          We implement appropriate technical and organizational measures to protect your data,
          including encryption in transit and at rest. Message transcripts are masked where
          required for public invoice links.
        </p>
      </section>

      <section>
        <h2
          className="mono"
          style={{
            letterSpacing: "0.1em",
            textTransform: "uppercase",
            fontSize: "1rem",
            marginBottom: "12px",
            color: "var(--accent-text)",
          }}
        >
          Contact Us
        </h2>
        <p style={{ color: "var(--text)", lineHeight: 1.7 }}>
          For privacy-related inquiries or to exercise your rights:
          <br />
          Email:{" "}
          <a href="mailto:privacy@salesdemon.ai" style={{ color: "var(--accent-text)" }}>
            privacy@salesdemon.ai
          </a>
          <br />
          We respond within two business days.
        </p>
      </section>

      <footer
        style={{
          marginTop: "16px",
          paddingTop: "20px",
          borderTop: "1px solid var(--rail)",
          display: "flex",
          flexWrap: "wrap",
          gap: "16px",
        }}
      >
        <Link
          to="/legal/sms-terms"
          className="mono small"
          style={{ color: "var(--accent-text)", letterSpacing: "0.08em" }}
        >
          SMS Terms →
        </Link>
        <Link
          to="/legal/sms-compliance"
          className="mono small"
          style={{ color: "var(--accent-text)", letterSpacing: "0.08em" }}
        >
          SMS Message Flow →
        </Link>
        <Link
          to="/legal/terms"
          className="mono small"
          style={{ color: "var(--accent-text)", letterSpacing: "0.08em" }}
        >
          Terms of Service →
        </Link>
        <Link
          to="/"
          className="mono small"
          style={{ color: "var(--muted)", letterSpacing: "0.08em" }}
        >
          ← Back to Home
        </Link>
      </footer>
    </article>
  )
}
